import type { FC } from 'react';
import { useMemo } from 'react';
import type { IBreadcrumbItem } from '@/DesignSystem/Model/DataModel';
import { LINKS } from '@/Module/Core/Constant';
import { DefaultLayoutBreadcrumb } from '@/Module/DefaultLayout/Component';
const TeacherListBreadcrumb: FC = () => {
  const items: IBreadcrumbItem[] = useMemo(() => {
    return [{
      key: 'CATEGORIES',
      title: 'معلم‌ها',
      href: LINKS.TEACHER_LIST
    }];
  }, []);
  return <DefaultLayoutBreadcrumb items={items} noMargin data-sentry-element="DefaultLayoutBreadcrumb" data-sentry-component="TeacherListBreadcrumb" data-sentry-source-file="TeacherListBreadcrumb.tsx" />;
};
export default TeacherListBreadcrumb;